import React, { memo } from "react";
import shallow from "zustand/shallow";
import CustomModal from "../CustomModal/CustomModal";
import DefaultIcon from "../../../assets/icons/default_icon.jpg";
import { useStoreRoom, useStoreSystem } from "../../../store";
import Stack from "@mui/material/Stack";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import styles from "./DecorsModal.module.scss";
import useCategoryTypes from "./hooks/useCategoryTypes";
import { OriginDecorI } from "../../../shared";
import { Button } from "@mui/material";
import { ToggleButton } from "../../shared/ui/ToggleButton";

type IncomingPropertiesType = {
    category: string | undefined;
};

const DecorsModal: React.FunctionComponent<IncomingPropertiesType> = memo(({ category }) => {
    const { addDecorAction } = useStoreRoom(
        (state) => ({
            addDecorAction: state.addDecor,
        }),
        shallow
    );
    // region state
    const { decorsModal, setDecorsModal, currentOriginDecors, currentOriginCategoryName } = useStoreSystem(
        (state) => ({
            decorsModal: state.decorsModal,
            setDecorsModal: state.setDecorsModal,
            currentOriginDecors: state.currentOriginDecors,
            currentOriginCategoryName: state.currentOriginCategoryName,
        }),
        shallow
    );

    const { types, selectedTypes, handleChangeTypes } = useCategoryTypes();
    const filtered = currentOriginDecors.filter((decor) => selectedTypes.includes(decor.TYPE_MODEL.CODE));

    // endregion

    const handleAddFurniture = (originDecor: OriginDecorI) => () => {
        addDecorAction(originDecor);
        setDecorsModal(false, undefined);
    };

    return (
        <CustomModal
            isOpenModal={decorsModal.isOpen}
            onCloseModalCallback={() => {
                setDecorsModal(false, undefined);
            }}
            // style={{ height: "50vh" }}
        >
            <div className={styles.root}>
                <Stack direction="row" spacing={4} alignItems="center">
                    <span>{currentOriginCategoryName}</span>
                    <ToggleButtonGroup
                        color={"primary"}
                        value={selectedTypes}
                        onChange={handleChangeTypes}
                        aria-label="Types"
                    >
                        {types.map((type) => (
                            <ToggleButton key={type.id} value={type.id} className={styles.tab} aria-label={type.name}>
                                {type.name}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </Stack>
                <div className={filtered.length ? styles.grid : styles.emptyGrid}>
                    {filtered.map((decor) => (
                        <div key={decor.ID} className={styles.item}>
                            <img
                                className={styles.itemImg}
                                src={decor.PICTURE || DefaultIcon}
                                alt={decor.NAME}
                                width={100}
                            />
                            <div className={styles.itemName}>{decor.NAME}</div>
                            <Button className={styles.itemBtn} variant="contained" onClick={handleAddFurniture(decor)}>
                                Добавить
                            </Button>
                        </div>
                    ))}
                    {!filtered.length && <div className={styles.notFoundElements}>Элементов не найдено</div>}
                </div>
            </div>
        </CustomModal>
    );
});

export default DecorsModal;
